module.exports = __webpack_public_path__ + "img/newsImg11-21.51805c21.png";